import React, { Fragment } from 'react';
import { Typography } from '@mui/material';
import { Alert } from '@components/Alert';
import { useTranslation } from 'react-i18next';
import {
  getCompetitionRankingMethodTranslationKey,
  getCompetitionRankingQualificationTranslationKey,
} from '@helpers/competitionRankingRules';
import { ICompetitionRankingRulesAlert } from './interfaces';

export const CompetitionRankingRulesAlert: React.FC<
  ICompetitionRankingRulesAlert
> = ({
  rankingMethod,
  minCountingScores,
  rankingBestN,
  format = 'self_paced',
  audience = 'portal',
  titleTranslationKey = 'portalTitle',
}): JSX.Element => {
  const { t } = useTranslation();

  const methodParams =
    rankingMethod === 'best_n_average' && rankingBestN != null
      ? { bestN: rankingBestN }
      : undefined;

  return (
    <Alert
      severity="info"
      title={t(`competitions:rankingRules.${titleTranslationKey}`)}
      content={
        <Fragment>
          <Typography variant="body2" component="p" sx={{ mb: 1 }}>
            {t(getCompetitionRankingQualificationTranslationKey(format, audience), {
              min: minCountingScores,
            })}
          </Typography>
          <Typography variant="body2" component="p">
            {t(
              getCompetitionRankingMethodTranslationKey(rankingMethod, audience),
              methodParams
            )}
          </Typography>
        </Fragment>
      }
    />
  );
};
